import {
  CREATE_IVR_CREDENTIAL,
  UPDATE_IVR_CREDENTIAL,
  GET_IVR_CREDENTIAL,
  CALL_LEAD,
  CALL_DIALER,
  GET_INCOMING_CALL,
  GET_OUTGOING_CALL,
} from '../actions/IVR.action';

const initialState = {
  createIvrCredential: '',
  updateIvrCredential: '',
  getIvrCredential: '',
  callLead: '',
  callDialer: '',
  getIncomingCall: '',
  getOutgoingCall: '',
};

const ivrReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_IVR_CREDENTIAL:
      return { ...state, createIvrCredential: action.payload };
    case UPDATE_IVR_CREDENTIAL:
      return { ...state, updateIvrCredential: action.payload };
    case GET_IVR_CREDENTIAL:
      return { ...state, getIvrCredential: action.payload };
    case CALL_LEAD:
      return { ...state, callLead: action.payload };
    case CALL_DIALER:
      return { ...state, callDialer: action.payload };
    case GET_INCOMING_CALL:
      return { ...state, getIncomingCall: action.payload };
    case GET_OUTGOING_CALL:
      return { ...state, getOutgoingCall: action.payload };
    default:
      return state;
  }
};

export default ivrReducer;